module.exports = __webpack_public_path__ + "media/images/point/reading-to-point-new-f25fdcb2b861f2101bdb831a06e9288f.png";